import { render } from "./SolicitudCentroCosto.vue?vue&type=template&id=f61b850e&scoped=true"
import script from "./SolicitudCentroCosto.vue?vue&type=script&lang=js"
export * from "./SolicitudCentroCosto.vue?vue&type=script&lang=js"

import "./SolicitudCentroCosto.vue?vue&type=style&index=0&id=f61b850e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61b850e"]])

export default __exports__